import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import AiGenerativeTextSummaryIcon from '@atlaskit/icon/core/ai-generative-text-summary';
import Button from '@atlaskit/button/new';

import { messages } from '../messages';

import { useShowLoomScriptPanel } from './loom-script-panel/useShowLoomScriptPanel';

export type ViewScriptButtonProps = {
	onRecordVideoClick?: () => void;
	isLoading?: boolean;
};

export const ViewScriptButton = ({
	onRecordVideoClick,
	isLoading = false,
}: ViewScriptButtonProps) => {
	const { showLoomScriptPanel } = useShowLoomScriptPanel();
	const handleClick = () => {
		showLoomScriptPanel(onRecordVideoClick, isLoading);
	};
	return (
		<Button iconBefore={AiGenerativeTextSummaryIcon} onClick={handleClick} appearance="subtle">
			<FormattedMessage {...messages.viewScriptButton} />
		</Button>
	);
};
